import {StyleSheet} from 'react-native';

import {indent, screenWidth} from '/constant/layout.constant';

export const snapToInterval = screenWidth() - indent * 5;

export const styles = StyleSheet.create({
  container: {
    width: screenWidth() - indent * 4,
  },
  heading: {
    textAlign: 'left',
    marginTop: indent,
    marginLeft: indent,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: indent,
    marginHorizontal: indent,
  },
  contentWrapper: {
    marginLeft: indent,
  },
  carouselContainer: {
    flexDirection: 'row',
    marginTop: indent,
  },
  itemContainer: {
    width: screenWidth() - indent * 6,
    marginRight: indent,
    marginBottom: indent,
  },
  sectionTitle: {
    marginBottom: indent / 4,
  },
  sectionSubtitle: {
    marginBottom: indent / 4,
  },
  itemListContainer: {
    marginTop: indent / 4,
  },
  sectionListItem: {
    marginBottom: indent / 4,
  },
});
